export const DEFAULT_DESCRIPTION = 'Для правильной обработки результатов этого теста необходим доступ к некоторым разделам. Без них формирование результатов не гарантируется';
